import { useSyncExternalStore } from 'react'
import {
  currentLocale,
  setLocaleManually,
  subscribeLocale,
  supportedLocaleOptions,
  translate,
  type TranslationParams,
} from './catalog'

export function useI18n() {
  const locale = useSyncExternalStore(subscribeLocale, currentLocale, currentLocale)

  return {
    locale,
    locales: supportedLocaleOptions(),
    setLocale: setLocaleManually,
    t: (key: string, params: TranslationParams = {}, fallback?: string) =>
      translate(locale, key, params, fallback),
  }
}
